import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Thumbs } from 'swiper';
import styled, { css } from 'styled-components';

import ArrowIcon from '@/assets/svg/detailed-car/arrow.svg';
import {
  BottomSliderProps,
  DetailedCarGalleryImageItem,
} from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import { colors } from '@/constants/theme';
import Picture from '@/components/Picture';
SwiperCore.use([Navigation, Thumbs]);

function BottomSliderModal({
  images,
  setSlider,
  subneilsPerView,
  currentSlideIndex,
}: BottomSliderProps) {
  const prevNavButtonRef = useRef<HTMLDivElement>(null);
  const nextNavButtonRef = useRef<HTMLDivElement>(null);
  const isLooper = (subneilsPerView || 5) < images.length;
  return (
    <>
      <Component subneilsPerView={subneilsPerView}>
        <Swiper
          slidesPerView={subneilsPerView}
          slidesPerGroup={1}
          spaceBetween={5}
          onSwiper={setSlider}
          loop={isLooper}
          allowTouchMove={false}
          navigation={{
            prevEl: prevNavButtonRef.current,
            nextEl: nextNavButtonRef.current,
          }}
        >
          {images.map((item: DetailedCarGalleryImageItem, index: number) => {
            function isActive() {
              if (currentSlideIndex > images.length) {
                return 1 === index + 1;
              } else if (currentSlideIndex < 1) {
                return images.length === index + 1;
              } else {
                return currentSlideIndex === index + 1;
              }
            }
            return (
              <SwiperSlide key={index}>
                <StyledPicture
                  mobileSmall={{ src: item.desktop }}
                  tabletSmall={{ src: item.desktop }}
                  isActive={isActive()}
                  loading="lazy"
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        {isLooper && (
          <>
            <StyledNavButtonWrapper ref={prevNavButtonRef} prev>
              <ArrowIcon />
            </StyledNavButtonWrapper>

            <StyledNavButtonWrapper ref={nextNavButtonRef} next>
              <ArrowIcon />
            </StyledNavButtonWrapper>
          </>
        )}
      </Component>
    </>
  );
}

export default BottomSliderModal;

const StyledNavButtonWrapper = styled.div<{
  next?: boolean;
  prev?: boolean;
}>`
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  bottom: 0;
  border-radius: 8px;
  padding: 0 2%;
  z-index: 10001;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  :hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
  svg {
    path {
      fill: ${colors.white};
    }
  }
  ${({ next }) =>
    next &&
    css`
      right: 0;
    `}
  ${({ prev }) =>
    prev &&
    css`
      left: 0;
      transform: rotate(180deg);
    `}
`;

const Component = styled.div<{
  subneilsPerView: number;
}>`
  margin-top: 20px;
  background-color: inherit;
  border-radius: 8px;
  position: relative;
  .swiper-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 88%;
  }
  .swiper-slide {
    cursor: pointer;
    border-radius: 11px;
    &:before {
      border-radius: 5px;
      z-index: 2;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &-active {
      filter: brightness(1);
      background: rgba(0, 0, 0, 0.1);

      &:before {
        display: none;
      }

      // & > div {
      //   & > picture {
      //     box-shadow: 0 0 0 3px ${colors.main};
      //   }
      // }
    }
  }
  ${({ subneilsPerView }) =>
    subneilsPerView >= 6
      ? css`
          padding-top: 9%;
        `
      : subneilsPerView === 5
      ? css`
          padding-top: 11%;
        `
      : subneilsPerView === 4
      ? css`
          padding-top: 15%;
        `
      : subneilsPerView === 3
      ? css`
          padding-top: 19%;
        `
      : subneilsPerView === 2
      ? css`
          padding-top: 25%;
        `
      : css`
          padding-top: 0;
        `}
`;

export const StyledPicture = styled(Picture)<{ isActive: boolean }>`
  position: static !important;

  img,
  picture {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    filter: brightness(0.5);
    background: rgba(0, 0, 0, 0.5);
  }

  img {
    object-fit: cover;
  }
  ${({ isActive }) =>
    isActive &&
    css`
      img,
      picture {
        filter: brightness(1);
        background: rgba(0, 0, 0, 0.1);
      }
      picture {
        border: 3px solid ${colors.main};
      }
    `}
`;
